import { useMutation, useQueryClient } from '@tanstack/react-query'
import { bulkDeletePlanAndRateOverrideRules } from '../../../api/plan-and-rate-override-rules-api'
import type { BulkDeletePlanAndRateOverrideRulesRequestDto } from '../../../api/dto/plan-and-rate-override-rules.dto'
import { PLAN_AND_RATE_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanAndRateOverride/hooks/useGetPlanAndRateOverrideRules'

export function useBulkDeletePlanAndRateOverrideRules() {
  const queryClient = useQueryClient()

  return useMutation<
    void,
    unknown,
    BulkDeletePlanAndRateOverrideRulesRequestDto
  >({
    mutationFn: (body) => bulkDeletePlanAndRateOverrideRules(body),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [PLAN_AND_RATE_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
